<template>
  <div
    id="login"
    class="modal fade black-modal"
    role="dialog"
    data-backdrop="true"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-header-inner">
            <!-- <span class="icon-login"></span> -->
            <span class="modal-title">ลงชื่อเข้าใช้</span>
          </div>
          <div class="modal-close" data-dismiss="modal">
            <i class="fa fa-times" aria-hidden="true"></i>
          </div>
        </div>
        <div class="modal-body">
           
          <div class="modal-cont normalLogin">
            <form class="normal-login-form" novalidate="novalidate">
              <div class="form-group form-special">
                
                <div class="input-holder">
                  <span class="input-icon">
                    <i class="fa-solid fa-user"></i>
                  </span>
                  <input
                    id="login_username"
                    name="login_username"
                    type="text"
                    class="form-control"
                    v-model="phoneNumber"

                    data-type="normal"
                    autocomplete="off"
                    placeholder="ชื่อผู้ใช้ (เบอร์โทรศัพท์)"

                  />
                </div>
                <div class="jErr"></div>
              </div>
              <div class="form-group form-special">
                <!-- <div class="label-container">
                              รหัสผ่าน                            </div> -->
                <div class="input-holder">
                  <span class="input-icon">
                    <i class="fa-solid fa-unlock-keyhole"></i>
                  </span>
                  <input
                    id="login_password"
                    name="login_password"
                    type="password"
                    :type="showpass == false ? 'password' : 'text'"
                    class="form-control"
                    data-type="normal"
                    autocomplete="off"
                    v-model="password"
                    placeholder="รหัสผ่าน"
                  />
                  <span class="input-icon" @click="showpass = !showpass">
                    <i class="fa-solid fa-eye-slash " v-if="showpass == false" ></i>
                    <i class="fa-solid fa-eye " v-if="showpass == true"></i>

                   </span>
                </div>
                <div class="jErr"></div>
              </div>
            </form>
            <div class="mLogin-rmbMe">
           
              <div>
                <label class="control control-checkbox">
                  <input type="checkbox"  v-model="remember"
                  :value="true" />
                  <div class="control_indicator"></div>
                  จำฉัน
                </label>
              </div>
              <div>
                <a  v-bind:href="`https://line.me/R/ti/p/${getLineId}`" target="_blank">
                <div id=" " class="pointer fs12">
                  ลืมรหัสผ่าน
                </div>
              </a>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="text-center pdb15">
              <div
                class="button button-big button-submit button-login-modal text-uppercase mgt30"
                data-type="normal"
                href="javascript:void(0)"
                @click="Login()"
              >
                เข้าสู่ระบบ
              </div>
              <!-- regModal -->
              <div class="text-white fs12 pdt15 mgb5">
                ยังไม่เป็นสมาชิก?<a
                  id="btnJoinNow"
                  class="btn-link-register pdl5"
                  href="javascript:void(0)"
                  @click="Register()"
                  >ลงทะเบียน</a
                >
              </div>
            </div>
          </div>

           
        </div>
      </div>
    </div>
  </div>

  <!-- <div id="authModal">
    <div class="loginmodaldiv" id="login" data-backdrop="false">
      <div class="modaldiv">
        <div class="contentmodal animate__animated animate__bounceInDown">
          <button class="closepopup" data-dismiss="modal">
            <i class="fas fa-times"></i>
          </button>
          <div class="login">
            <div class="logopopup">
              <img src="/static/img/logo/main_logo_20221004223046.png" />
            </div>
            <h1>เข้าสู่ระบบ</h1>
            <form id="form2">
              <input
                placeholder="ชื่อผู้ใช้ (เบอร์โทรศัพท์)"
                required="required"
                name="username"
                id="username"
                type="tel"
                value=""
                class="text_login mb-4 mt-3"
                v-model="phoneNumber"
              />
              <input
                v-model="password"
                placeholder="รหัสผ่าน"
                type="password"
                required="required"
                name="password"
                id="password"
                value=""
                class="text_login"
              />
              <a
                href="javascript:void(0)"
                @click="Login()"
                id="btnLogin"
                class="btnLogin"
                >เข้าสู่ระบบ</a
              >
            </form>
            <div class="modalspanbox">
              ยังไม่เป็นสมาชิก?
              <a
                href="javascript:void(0)"
                @click="Register()"
                class="registerbtn"
                >สมัครสมาชิก</a
              >
            </div>
          </div>
        </div>
        <div class="overlaymodal"></div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "LoginForm",
  data() {
    return {
      phoneNumber: "",
      password: "",
      showpass: false,
      remember: false,
    };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
    ]),
  },
  methods: {
    ...mapActions(["userSignIn", "setError"]),
    async Login() {
      if (
        this.phoneNumber == "" ||
        this.password == "" ||
        this.phoneNumber.length !== 10
      ) {
        return this.$swal.fire(
          "เบอร์โทรศัพท์ หรือ รหัสผ่าน ไม่ถูกต้อง",
          "",
          "error"
        );
      }
      await this.userSignIn({
        phoneNumber: this.phoneNumber,
        password: this.password,
      });
      if (this.getError) {
        return this.$swal.fire(this.getError, "", "error");
      } else {
        // $('#modalLogin').modal('hide')
        if (this.remember == true) {
          localStorage.setItem("remember.username", this.phoneNumber);
          localStorage.setItem("remember.password", this.password);
        } else {
          localStorage.removeItem("remember.username");
          localStorage.removeItem("remember.password");
        }
        localStorage.removeItem("modal-alert");
      }
    },
    async Register() {
      $("#login").modal("hide");
      $("#regModal").modal("show");
    },
  },
  mounted() {
    this.setError(null);
    if (localStorage.getItem("remember.username") != null) {
      this.phoneNumber = localStorage.getItem("remember.username");
      this.remember = true;
    }
    if (localStorage.getItem("remember.password") != null) {
      this.password = localStorage.getItem("remember.password");
      this.remember = true;
    }
    $(".overlaymodal").on("click", function() {
      $("#login").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/LoginForm.vue